import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const SliderContactUsCMS = () => {
  const [imageContactUs, setImageContactUs] = useState([]);
  const [textContactUs, setTextContactUs] = useState([]);
  const [newImage, setNewImage] = useState(null);
  const [newText, setNewText] = useState('');
  const [addSuccessMessage, setAddSuccessMessage] = useState('');
  const [addError, setAddError] = useState('');
  const [updateSuccessMessage, setUpdateSuccessMessage] = useState('');
  const [updateError, setUpdateError] = useState('');
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [contactUsToDelete, setContactUsToDelete] = useState(null);
  const [editingImageContactUs, setEditingImageContactUs] = useState(null);
  const [editingTextContactUs, setEditingTextContactUs] = useState(null);
  const [imageErrorUpdate, setImageErrorUpdate] = useState('');

  useEffect(() => {
    fetchContactUsImages();
    fetchContactUsTexts();
  }, []);

  const fetchContactUsImages = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderContactUs/listImages');
      setImageContactUs(response.data.data);
    } catch (error) {
      console.error('Error fetching contact us images:', error);
    }
  };

  const fetchContactUsTexts = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderContactUs/listTexts');
      setTextContactUs(response.data.data);
    } catch (error) {
      console.error('Error fetching contact us texts:', error);
    }
  };

  const addContactUsImage = async () => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.post('https://back.zubilaw.com/SliderContactUs/addImage', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setAddSuccessMessage('Contact us image added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewImage(null);
      fetchContactUsImages();
    } catch (error) {
      setAddError('Please select an image to upload.');
      console.error('Error adding contact us image:', error);
    }
  };

  const addContactUsText = async () => {
    const data = {
      text: newText,
    };

    try {
      await axios.post('https://back.zubilaw.com/SliderContactUs/addText', data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setAddSuccessMessage('Contact us text added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewText('');
      fetchContactUsTexts();
    } catch (error) {
      setAddError('Please enter text to add.');
      console.error('Error adding contact us text:', error);
    }
  };

  const updateContactUsImage = async (id) => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.put(`https://back.zubilaw.com/SliderContactUs/updateImage/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setUpdateSuccessMessage('Contact us image updated successfully!');
      setEditingImageContactUs(null);
      setNewImage(null);
      fetchContactUsImages();
    } catch (error) {
      setUpdateError('Error updating contact us image.');
      console.error('Error updating contact us image:', error);
    }
  };

  const updateContactUsText = async (id) => {
    const data = {
      text: newText,
    };

    try {
      await axios.put(`https://back.zubilaw.com/SliderContactUs/updateText/${id}`, data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setUpdateSuccessMessage('Contact us text updated successfully!');
      setEditingTextContactUs(null);
      setNewText('');
      fetchContactUsTexts();
    } catch (error) {
      setUpdateError('Error updating contact us text.');
      console.error('Error updating contact us text:', error);
    }
  };

  const deleteContactUs = (id) => {
    setContactUsToDelete(id);
    setShowDeletePopup(true);
  };

  const performDelete = async () => {
    try {
      await axios.delete(`https://back.zubilaw.com/SliderContactUs/delete/${contactUsToDelete}`);
      setShowDeletePopup(false);
      fetchContactUsImages();
      fetchContactUsTexts();
    } catch (error) {
      console.error('Error deleting contact us:', error);
    }
  };

  const closeUpdateForm = () => {
    setEditingImageContactUs(null);
    setEditingTextContactUs(null);
    setNewImage(null);
    setNewText('');
  };


  const modules = {
    toolbar: [
      [{ 'color': [] }, { 'background': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': '1' }, { 'header': '2' }, { 'header': [3, 4, 5, 6] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']                                         
    ],
  };
  
  const formats = [
    'background', 'color', 'bold', 'italic', 'underline', 'strike', 'header',
    'list', 'bullet', 'align', 'link', 'image', 'video'
  ];

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Manage Contact Us Images</CardTitle>
            </CardHeader>
            <CardBody>
              <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label>Image</label>
                      <Input
                        type="file"
                        onChange={(e) => setNewImage(e.target.files[0])}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      className="btn-round"
                      color="primary"
                      onClick={addContactUsImage}
                    >
                      Add Contact Us Image
                    </Button>
                    {addSuccessMessage && (
                      <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                        {addSuccessMessage}
                      </div>
                    )}
                    {addError && (
                      <div style={{ color: "red", marginTop: "5px" }} role="alert">
                        {addError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form>
              <Table responsive>
  <thead className="text-primary">
    <tr>
      <th>Image</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {imageContactUs.map((contactUs, index) => (
      <tr key={contactUs.id}>
        <td>
          <img
            src={`https://back.zubilaw.com/${contactUs.slider}`}
            alt="Contact Us Slider"
            style={{ maxWidth: '300px', maxHeight: '200px' }}
          />
        </td>
        <td>
          <Button
            color="success"
            onClick={() => {
              setEditingImageContactUs(contactUs);
              setNewImage(null);
            }}
          >
            Update Image
          </Button>{" "}
          {index !== 0 && (
            <Button
              color="danger"
              onClick={() => deleteContactUs(contactUs.id)}
            >
              Delete
            </Button>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</Table>

            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Text Details</CardTitle>
            </CardHeader>
            <CardBody>
  
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th>Text</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {textContactUs.map((contactUs) => (
                    <tr key={contactUs.id}>
                      <td dangerouslySetInnerHTML={{ __html: contactUs.text }}></td>
                      <td>
                        <Button
                          color="success"
                          onClick={() => {
                            setEditingTextContactUs(contactUs);
                            setNewText(contactUs.text);
                          }}
                        >
                          Update Text
                        </Button>{" "}
                        {/* <Button
                          color="danger"
                          onClick={() => deleteContactUs(contactUs.id)}
                        >
                          Delete
                        </Button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {(editingImageContactUs || editingTextContactUs) && (
        <CardFooter>
          <Form>
            <Row>
              {editingTextContactUs && (
                <Col md="7">
                  <FormGroup>
                    <label>Text</label>
                    <div
                      style={{
                        height: '300px',
                        overflowY: 'auto',
                      }}
                    >
                      <ReactQuill
                        value={newText}
                        onChange={setNewText}
                        modules={modules} 
                        formats={formats}
                        style={{ height: '80%', color: 'black' }}
                        />
                    </div>
                  </FormGroup>
                </Col>
              )}

              {editingImageContactUs && (
                <Col md="6">
                  <FormGroup>
                    <label>Image</label>
                    <Input
                      type="file"
                      onChange={(e) => setNewImage(e.target.files[0])}
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md="12">
                {editingTextContactUs && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateContactUsText(editingTextContactUs.id)}
                  >
                    Update Text
                  </Button>
                )}{" "}
                {editingImageContactUs && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateContactUsImage(editingImageContactUs.id)}
                  >
                    Update Image
                  </Button>
                )}{" "}
                <Button
                  className="btn-round"
                  color="secondary"
                  onClick={closeUpdateForm}
                >
                  Cancel
                </Button>
                {updateSuccessMessage && (
                  <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateSuccessMessage}
                  </div>
                )}
                {updateError && (
                  <div className="alert alert-danger" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateError}
                  </div>
                )}
                {imageErrorUpdate && (
                  <div style={{ color: 'red' }}>
                    {imageErrorUpdate}
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </CardFooter>
      )}

      <Modal isOpen={showDeletePopup} toggle={() => setShowDeletePopup(false)}>
        <ModalHeader toggle={() => setShowDeletePopup(false)}>Delete Contact Us</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this contact us?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={performDelete}>Delete</Button>
          <Button color="secondary" onClick={() => setShowDeletePopup(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SliderContactUsCMS;
